module.exports = __webpack_public_path__ + "img/Janssen Pharmaceutica.feaedbbd.jpg";